import axios from 'axios';
import {
  SOCIAL_MEDIA_LIST_ENDPOINT,
  SOCIAL_MEDIA_ENDPOINT
} from '@dynameat/constants';

export const socialMediaListRequest = () => axios.get(SOCIAL_MEDIA_LIST_ENDPOINT());
export const createSocialMediaRequest = (socialMedia) => axios.post(SOCIAL_MEDIA_ENDPOINT(), socialMedia);
export const updateSocialMediaRequest = (socialMediaGuid, socialMedia) => axios.patch(SOCIAL_MEDIA_ENDPOINT(socialMediaGuid), socialMedia);
export const deleteSocialMediaRequest = (socialMediaGuid) => axios.delete(SOCIAL_MEDIA_ENDPOINT(socialMediaGuid));
